import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectorAuthenticated } from '@/stores/auth';
import { Wrapper } from './styles';

const AuthLayout = () => {
  const isAuthenticated = useSelector(selectorAuthenticated);
  const location = useLocation();
  const isLoginPage = location.pathname === '/auth/login';

  if (isAuthenticated && !isLoginPage) {
    const queryParams = new URLSearchParams(window.location.search);
    const redirect = queryParams.get('redirect');
    return <Navigate to={redirect || '/'} replace />;
  }

  return (
    <Wrapper>
      <Outlet />
    </Wrapper>
  );
};

export default AuthLayout;
